import { FunctionComponent, ReactElement } from "react";

// Components
import DataTable from "../../../../shared/DataTable/DataTable";

// Utils
import { DataTableColumn, PaginatedApiResponse, SortDirection } from "../../../../utils/types";

// Hooks
import { IParams } from "../../../../shared/DataTable/hooks/useSearchParams";

interface AttorneyClaimsProps {
	claimsData: PaginatedApiResponse;
	columns: Array<DataTableColumn>;
	searchParams: URLSearchParams;
	isLoading?: boolean;
	handleFetchClaims: (cacheKey: string) => void;
}

const defaultClaimsParams: Partial<IParams> = {
	sortDirection: SortDirection.Desc,
	sortField: "submittedAt"
};

/** A table of an attorney's claims */
const AttorneyClaims: FunctionComponent<AttorneyClaimsProps> = (props: AttorneyClaimsProps): ReactElement => {
	const { claimsData, columns, searchParams, isLoading, handleFetchClaims } = props;

	return (
		<DataTable
			data={claimsData}
			columns={columns}
			refetchTrigger={handleFetchClaims}
			defaultParams={defaultClaimsParams}
			existingParams={searchParams}
			shouldUpdateUrl={true}
			shouldShowSelection={false}
			shouldShowFilterToggle={false}
			shouldShowTableContainer={true}
			isLoading={isLoading}
		/>
	);
};

export default AttorneyClaims;
